import React, { useState } from "react";
import PropTypes from "prop-types";
import TodoItem from "./TodoItem";
import { AiOutlineMenu } from "react-icons/ai";
import "../styles/TodoList.css";

function TodoList({ todos, updateTodo, deleteTodo, isDarkMode }) {
  const [showActions, setShowActions] = useState(false);

  const toggleActions = () => {
    setShowActions((prevState) => !prevState);
  };

  return (
    <div className="todo-list-container">
<button
  className={`btn btn-secondary mb-3 ${isDarkMode ? "text-light" : "text-dark"}`}
  onClick={toggleActions}
  aria-label="Toggle actions"
>
  <AiOutlineMenu /> {showActions ? "Ẩn chức năng" : "Hiện chức năng"}
</button>
      {todos.length === 0 ? (
        <div className="todo-list-empty">Danh sách nhiệm vụ trống</div>
      ) : (
        <ul className="list-group">
          {todos.map((todo) => (
            <TodoItem
              key={todo.id}
              todo={todo}
              updateTodo={updateTodo}
              deleteTodo={deleteTodo}
              showActions={showActions}
              isDarkMode={isDarkMode}
            />
          ))}
        </ul>
      )}
    </div>
  );
}

TodoList.propTypes = {
  todos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      task: PropTypes.string.isRequired,
      completed: PropTypes.bool.isRequired,
      pinned: PropTypes.bool.isRequired,
    })
  ).isRequired,
  updateTodo: PropTypes.func.isRequired,
  deleteTodo: PropTypes.func.isRequired,
  isDarkMode: PropTypes.bool.isRequired,
};

export default TodoList;
